module.exports = __webpack_public_path__ + "static/media/BG-assurance-maladie.fca5285c.svg";